import React, { useEffect } from 'react';
import { useUI } from "../../stores/useUI";
import { UIStyles } from "./styles";

const LoadingTracker = () => {
  const {loadingProgress, loadedItems, totalItems } = useUI(state => state.loadingTracker);
  const { setStartGame, setLoadingProgress } = useUI(state => state);
  const progressPercentage = loadingProgress * 100;
  
  useEffect(() => {
    const progress = loadedItems / totalItems;
    setLoadingProgress(progress ? progress : 0);
    if (progress === 1) {
      setTimeout(() => {
        setStartGame(true);
      }, 500);
    }
  }, [loadedItems, totalItems]);

  return (
    <div style={styles.container}>
      
      {/* Main Content */}
      <div style={styles.contentContainer}>
        {/* Logo */}
        <img 
          src="/graph_logo.png" 
          alt="Graph Surfer Logo" 
          style={styles.logo}
        />
        
        {/* Loading Text */}
        <div style={styles.loadingText}>
          Loading Game Assets...
        </div>
        
        {/* Progress Bar Container */}
        <div style={styles.progressBarContainer}>
          {/* Progress Fill */}
          <div style={{
            ...styles.progressFill,
            width: `${progressPercentage}%`,
          }}>
            {/* Animated Shine Effect */}
            <div style={styles.shineEffect} />
          </div>
        </div>
        
        {/* Progress Percentage and Stats */}
        <div style={styles.progressStats}>
            <span>{progressPercentage.toFixed(0)}%</span>
            <span>{loadedItems} / {totalItems}</span>
        </div>
        
        {/* Loading Tips */}
        <div style={styles.loadingTips}>
          {progressPercentage < 25 && "Initializing game world..."}
          {progressPercentage >= 25 && progressPercentage < 50 && "Loading character models..."}
          {progressPercentage >= 50 && progressPercentage < 75 && "Preparing NPCs..."}
          {progressPercentage >= 75 && progressPercentage < 100 && "Finalizing assets..."}
          {progressPercentage === 100 && "Ready to play!"}
        </div>
      </div>
      
      {/* CSS Animations */}
      <style>{`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}</style>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#efeee7', // Neutral background
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Inter, sans-serif',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '500px',
    padding: '40px',
  },
  logo: {
    width: '150px',
    height: 'auto',
    objectFit: 'contain',
    marginBottom: '40px',
  },
  loadingText: {
    fontSize: '18px',
    color: UIStyles.colors.text,
    marginBottom: '20px',
    fontWeight: 500,
  },
  progressBarContainer: {
    width: '100%',
    height: '18px',
    background: 'rgba(37, 34, 36, 0.1)',
    borderRadius: '20px',
    overflow: 'hidden',
    marginBottom: '15px',
    border: '1.5px solid #521616',
    boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  progressFill: {
    height: '100%',
    background: 'linear-gradient(90deg, #d498ac 0%, #ecd3d5 100%)',
    borderRadius: '20px',
    transition: 'width 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
  },
  shineEffect: {
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    animation: 'shine 2s infinite',
  },
  progressStats: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    fontSize: '14px',
    color: '#666',
    fontWeight: 500,
  },
  loadingTips: {
    fontSize: '14px',
    color: '#888',
    marginTop: '30px',
    fontStyle: 'italic',
    textAlign: 'center',
  },
};

export default LoadingTracker;